import { ContentComponent } from "components/flexComponents/Content/factory/ContentComponent";
import DynamicVendorContent from "components/flexComponents/Content/factory/impl/DynamicVendorContent";
import { ContentFlexComponent } from "components/flexComponents/Content/typings";
import { EditorialContentFactory } from "components/flexComponents/Content/factory/EditorialContentFactory";
import { NullContentComponent } from "components/flexComponents/Content/factory/NullContentComponent";

export class ContentFactory {
  public static get = (props: ContentFlexComponent): ContentComponent => {
    if (!props || !props.model || !props.name) {
      return new NullContentComponent(props);
    }

    if (props.name === "editorial") {
      return EditorialContentFactory.get(props);
    }

    if (props.name === "dynamic-vendor-content") {
      return new DynamicVendorContent(props);
    }

    return new NullContentComponent(props);
  };
}
